module.exports = __webpack_public_path__ + "img/icon-about-me.b3fe900c.svg";